import React from "react";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <p className="footer-text">
          Off Meta Fantasy is not endorsed by Riot Games and does not reflect the views or opinions of Riot Games or anyone officially involved in producing or
          managing Riot Games properties. Riot Games and all associated properties are trademarks or registered trademarks of Riot Games, Inc.
        </p>
        <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
          <a
            href="https://discord.gg/N5XwKXdrCY"
            target="_blank"
            rel="noopener noreferrer"
            className="discord-link">
            <img src="/discord.svg" alt="Join us on Discord" className="discord-icon" />
          </a>
          {/* <a
            href="https://discord.gg/your-invite-link"
            target="_blank"
            rel="noopener noreferrer"
            className="discord-link">
            <img src="/reddit.svg" alt="Join our reddit" className="discord-icon" />
          </a> */}
        </div>
      </div>
    </footer>
  );
}
